import React from 'react';
import './BackgroundPattern.css';

const BackgroundPattern = () => {
  return (
    <div className="background-pattern">
      <svg className="pattern-svg" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
            {/* Instrument panel grid */}
            <path d="M 40 0 L 0 0 0 40" fill="none" stroke="#333333" strokeWidth="0.5" opacity="0.15" />
          </pattern>
          
          <pattern id="contours" width="200" height="200" patternUnits="userSpaceOnUse">
            {/* Topographic contour lines */}
            <path
              d="M 0 100 Q 50 80, 100 100 T 200 100"
              fill="none"
              stroke="#333333"
              strokeWidth="0.5"
              opacity="0.08"
            />
            <path
              d="M 0 120 Q 50 100, 100 120 T 200 120"
              fill="none"
              stroke="#333333"
              strokeWidth="0.5"
              opacity="0.08"
            />
            <path
              d="M 0 80 Q 50 60, 100 80 T 200 80"
              fill="none"
              stroke="#333333"
              strokeWidth="0.5"
              opacity="0.08"
            />
          </pattern>
        </defs>
        
        <rect width="100%" height="100%" fill="url(#grid)" />
        <rect width="100%" height="100%" fill="url(#contours)" />
      </svg>
    </div>
  );
};

export default BackgroundPattern;
